"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPlayerRole = void 0;
///
/// Used to define user role in a session
///
var EPlayerRole;
(function (EPlayerRole) {
    EPlayerRole[EPlayerRole["ANIMATOR"] = 0] = "ANIMATOR";
    EPlayerRole[EPlayerRole["PLAYER"] = 1] = "PLAYER";
})(EPlayerRole || (EPlayerRole = {}));
exports.EPlayerRole = EPlayerRole;
